'use client'

import { useSafeBack } from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = {
  label?: string
  className?: string
  onClick?: () => void
}

export const CloseButton = ({ label = '닫기', className, onClick }: Props) => {
  const { goBack } = useSafeBack()

  const handleClick = () => {
    if (onClick) {
      onClick()

      return
    }

    goBack()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      className={className}
    >
      <Icon name="close" size={24} strokeWidth={1.5} />
      <span className="sr-only">{label}</span>
    </button>
  )
}
